export default "__VITE_ASSET__2J2iwrfj__"